import { Button } from '@rocco/components/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@rocco/components/dialog';

interface PaymentMethodTypePopupProps {
    isOpen: boolean;
    onClose: () => void;
    onPayOnline?: () => void;
    onPayLater?: () => void;
}

/**
 * Popup component for selecting payment method type
 * Provides options to pay online immediately or pay later
 */
export const PaymentMethodTypePopup = ({
    isOpen,
    onClose,
    onPayOnline,
    onPayLater,
}: PaymentMethodTypePopupProps) => {
    const handlePayOnline = () => {
        onPayOnline?.();
        onClose();
    };

    const handlePayLater = () => {
        onPayLater?.();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold text-gray-900">
                        Select Payment Method
                    </DialogTitle>
                </DialogHeader>
                <div className="mt-6 space-y-4">
                    <p className="text-gray-600">
                        Choose how you would like to proceed with your payment:
                    </p>
                    <div className="flex flex-col gap-3">
                        <Button
                            onClick={handlePayOnline}
                            className="h-12 w-full"
                            color="primary-bm"
                            size="xLarge"
                            shape="squareRounded"
                        >
                            <span className="text-[1.13rem] font-medium text-[#161616]">
                                Pay Online
                            </span>
                        </Button>
                        <Button
                            onClick={handlePayLater}
                            className="h-12 w-full"
                            color="white"
                            size="xLarge"
                            shape="squareRounded"
                        >
                            <span className="text-[1.13rem] font-medium text-[#161616]">
                                Pay Later
                            </span>
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
